import styled from 'styled-components';

export const Container = styled.div`
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    border: 1px solid #f0f0f0;
    width: 100%;
    height: 100%;
}
`;
